import documentUploadReducer from './documentUploadHistory';

export default documentUploadReducer;
